<!--
 Copyright (c) 2019
    Reliant Business Valuation, LLC - http://reliantvalue.com
    Author: Ronnel Bedana - ronnel@internalvaluation.com

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div class="modal-header">
  <h4 class="modal-title pull-left">Email Info</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="subject mt-2">
    <div class="d-flex justify-content-between">
      <label class="rbv-label">Subject:</label>
      <label class="rbv-label">Email Sent: <span style="font-weight: normal">{{email.DATE |date: 'MM/dd/yyyy hh:mm a'}}</span></label>
    </div>

    <input type="text" name="mailSubject" class="form-control rounded-0" [(ngModel)]="email.SUBJECT" disabled>
  </div>

  <div class="subject mt-2">
    <label class="rbv-label">Content:</label>
    <quill-editor [styles]="editorStyle" [(ngModel)]="email.CONTENT" [modules]="quillModules" disabled></quill-editor>
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-rbv primary" (click)="onCancel()">Ok</button>
</div>
